import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import RSVP from "rsvp";
import GooglePlusHelper from "models/helper/GooglePlusHelper";
import AppleIDHelper from "models/helper/AppleIDHelper";
import { INLINE_AUTH_MODES } from "models/helper/InlineAuthModes";
import Utils from "models/helper/Utils";
import pageTemplate from 'text!../../../templates/loginView/loginPageTemplate.html';
import pageMobileTemplate from 'text!../../../templates/loginView/loginPageTemplateMobile.html';
import popupTemplate from 'text!../../../templates/loginView/loginPopupTemplate.html';
import pagei18n from 'i18n!nls/loginPagei18n';
import popupi18n from 'i18n!nls/loginPopupi18n';
import Mousetrap from 'mousetrap';

const shouldWaitForCordovaBootstrap = function(){
    return typeof window !== "undefined" && !!window.waitForCordovaToLoad;
};
const USE_NEW_GOOGE_API_ON_WEB = true;

const LoginPageView = Backbone.View.extend({
    ptemplate : _.template(popupTemplate),

    _getTemplate : function(){
        return _.template(shouldWaitForCordovaBootstrap() ? pageMobileTemplate : pageTemplate);
    },

    initialize : function(options) {
        this._removeOnHide = true;
        this._showAsPopup = options ? options.showAsPopup : false;
        this._clickingOnSocialLoginWillSignupAutomatically = options ? options.clickingOnSocialLoginWillSignupAutomatically : false;
        this._doNotAllowGuestLogin = options ? options.doNotAllowGuestLogin : false;
        this._showOrganizationLogin = options ? options.showOrganizationLogin : false;
        this.isUserpreviouslyLoggedInAsGuest = options ? options.isUserpreviouslyLoggedInAsGuest : false;
        this._mousetrapObj = null;
        this._enabledColor = "var(--trebble-primary)";
        this._disabledColor = shouldWaitForCordovaBootstrap() ? "var(--trebble-primary)" : "#cccccc";
        this._ti18n = null;
        this._inlineAuthState = null;
    },

    shouldUseHostedSocialAuthButtons : function(){
        return Utils.getInstance().isBrowserHostedAuthEnvironment() || shouldWaitForCordovaBootstrap();
    },

    shouldShowAppleAuthButtons : function(){
        return Utils.getInstance().shouldShowAppleAuthButtons();
    },

    setDoNotAllowGuestLogin : function(doNotAllowGuestLogin){
        this._doNotAllowGuestLogin = !!doNotAllowGuestLogin;
        if(this.$el && this.$el.length){
            this.$el.find("#continueAsGuessBtn").toggle(!this._doNotAllowGuestLogin);
        }
    },

    navigateToPreviousPage : function(){
        window.history.back();
    },

    events : {
        "click #header-back-button" : "navigateToPreviousPage",
        "click #LoginBtn.enabled" : "onLoginBtnTapped",
        "click #SignUpBtn" : "onSignupBtnTapped",
        "click #requestInviteBtn" : "onRequestInviteBtnTapped",
        "click #UpdateGuessProfileBtn": "onSignupBtnTapped",
        "click #LoginWithFacebookBtn" : "onLoginWithFacebookBtnTapped",
        "click #LoginWithGoogleBtn" : "onLoginWithGoogleBtnTapped",
        "click #LoginWithAppleBtn" : "onLoginWithAppleBtnTapped",
        "click #LoginWithMagicCodeBtn" : "onLoginWithMagicCodeBtnTapped",
        "click #OrganizationLoginBtn" : "onOrganizationLoginBtnTapped",
        "click #continueAsGuessBtn": "onContinueAsGuessButtonTapped",
        "click .forgotPasswordLink" : "onForgotPasswordLinkClicked",
        "click #showEmailLoginFormBtn": "showEmailLoginFormBtn",
        "click #InlineAuthPrimaryBtn.enabled": "onInlineAuthPrimaryBtnTapped",
        "click #InlineAuthSecondaryBtn": "onInlineAuthSecondaryBtnTapped",
        "click #InlineAuthEmailField, #InlineAuthCodeField": "onInlineAuthFieldChanged",
        "blur #InlineAuthEmailField, #InlineAuthCodeField": "onInlineAuthFieldChanged",
        "keyup #InlineAuthEmailField, #InlineAuthCodeField": "onInlineAuthFieldChanged",
        "input #InlineAuthEmailField, #InlineAuthCodeField": "onInlineAuthFieldChanged"
    },

    onLoginBtnTapped : function(data){
        const resolvedData = data && data.username !== undefined ? data : null;
        const username = resolvedData ? resolvedData.username : this.$el.find("#usernameFieldInput").val();
        const password = resolvedData ? resolvedData.password : this.$el.find("#passwordField").val();
        this.trigger("loginBtnTapped", {
            username: username ? username.trim() : username,
            password: password
        });
    },

    onContinueAsGuessButtonTapped: function(){
        this.trigger("continueAsGuessBtnTapped");
    },

    onForgotPasswordLinkClicked: function(){
        this.trigger("forgotPasswordLinkClicked");
    },

    onLoginWithFacebookBtnTapped: function(){
        this.trigger("loginWithFacebookBtnTapped");
    },

    onLoginWithGoogleBtnTapped: function(event){
        if(this.shouldUseHostedSocialAuthButtons()){
            if(event && event.preventDefault){
                event.preventDefault();
            }
            this.trigger("loginWithGoogleBtnSuccess", null);
        }
    },

    onLoginWithAppleBtnTapped: function(){
        this.trigger("loginWithAppleBtnTapped");
    },

    onLoginWithMagicCodeBtnTapped: function(){
        this.trigger("loginWithMagicCodeBtnTapped");
    },

    onInlineAuthPrimaryBtnTapped : function(){
        if(!this._inlineAuthState){
            return;
        }

        this.trigger("inlineAuthSubmit", this.getInlineAuthData());
    },

    onInlineAuthSecondaryBtnTapped : function(){
        if(!this._inlineAuthState){
            return;
        }

        this.trigger("inlineAuthSecondaryAction", this.getInlineAuthData());
    },

    onOrganizationLoginBtnTapped: function(loginIdentifier){
        let resolvedLoginIdentifier = loginIdentifier;
        if(resolvedLoginIdentifier && resolvedLoginIdentifier.currentTarget){
            resolvedLoginIdentifier = null;
        }
        if(typeof resolvedLoginIdentifier !== "string"){
            resolvedLoginIdentifier = this.$el.find("#usernameFieldInput").val();
        }
        this.openInlineAuthFlow(INLINE_AUTH_MODES.SSO_EMAIL, {
            email: resolvedLoginIdentifier ? resolvedLoginIdentifier.trim() : "",
        });
    },

    showEmailLoginFormBtn : function(){
        this.$el.find(".loginFormWrapper").removeClass("hideLoginForm");
    },

    onSignupBtnTapped : function(){
        this.trigger("signupButtonTapped");
    },

    onRequestInviteBtnTapped : function(){
        this.trigger("requestInviteBtnTapped");
    },

    _getInlineAuthBundle : function(){
        return this._ti18n || (this._showAsPopup ? popupi18n : pagei18n);
    },

    _setInlineAuthPrimaryEnabled : function(isEnabled){
        if(!this.inlineAuthPrimaryBtn$el){
            return;
        }

        this.inlineAuthPrimaryBtn$el.toggleClass("enabled", !!isEnabled);
        this.inlineAuthPrimaryBtn$el.toggleClass("disabled", !isEnabled);
        this.inlineAuthPrimaryBtn$el.attr("aria-disabled", isEnabled ? "false" : "true");
    },

    onInlineAuthFieldChanged : function(){
        if(!this._inlineAuthState){
            return;
        }

        const mode = this._inlineAuthState.mode;
        const emailValue = this.inlineAuthEmailField$el ? this.inlineAuthEmailField$el.val() : "";
        const codeValue = this.inlineAuthCodeField$el ? this.inlineAuthCodeField$el.val() : "";

        let isValid = false;
        if(mode === INLINE_AUTH_MODES.MAGIC_EMAIL || mode === INLINE_AUTH_MODES.RESET_PASSWORD || mode === INLINE_AUTH_MODES.SSO_EMAIL){
            isValid = !!(emailValue && Utils.getInstance().getEmailRegexValidation().test(emailValue.trim().toLowerCase()));
        }else if(mode === INLINE_AUTH_MODES.MAGIC_CODE || mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            isValid = !!(codeValue && codeValue.toString().trim());
        }

        this._setInlineAuthPrimaryEnabled(isValid);
    },

    clearInlineAuthError : function(){
        if(this.inlineAuthError$el){
            this.inlineAuthError$el.hide().text("");
        }
    },

    setInlineAuthError : function(message){
        if(this.inlineAuthError$el){
            this.inlineAuthError$el.text(message || "").toggle(!!message);
        }
    },

    closeInlineAuthFlow : function(){
        this._inlineAuthState = null;
        if(this.loginForm$el){
            this.loginForm$el.removeClass("authFlowModeActive");
        }
        if(this.inlineAuthPanel$el){
            this.inlineAuthPanel$el.hide();
        }
        this.clearInlineAuthError();
        if(this.inlineAuthEmailField$el){
            this.inlineAuthEmailField$el.val("");
        }
        if(this.inlineAuthCodeField$el){
            this.inlineAuthCodeField$el.val("");
        }
        this._setInlineAuthPrimaryEnabled(false);
    },

    openInlineAuthFlow : function(mode, options){
        if(!this.inlineAuthPanel$el){
            return;
        }

        const resolvedOptions = options || {};
        const i18nBundle = this._getInlineAuthBundle();
        const email = resolvedOptions.email ? resolvedOptions.email.trim().toLowerCase() : "";
        let title = "";
        let description = "";
        let primaryLabel = "";
        let secondaryLabel = "";

        if(mode === INLINE_AUTH_MODES.MAGIC_EMAIL){
            title = window.getI18n(i18nBundle, "MAGIC_CODE_EMAIL_PROMPT_TITLE");
            description = window.getI18n(i18nBundle, "MAGIC_CODE_EMAIL_PROMPT_TEXT");
            primaryLabel = window.getI18n(i18nBundle, "MAGIC_CODE_SEND_BUTTON_LABEL");
            secondaryLabel = window.getI18n(i18nBundle, "AUTH_PANEL_BACK_TO_LOGIN");
        }else if(mode === INLINE_AUTH_MODES.SSO_EMAIL){
            title = window.getI18n(i18nBundle, "ORGANIZATION_LOGIN_BUTTON_LABEL");
            description = window.getI18n(i18nBundle, "ORGANIZATION_LOGIN_PANEL_TEXT");
            primaryLabel = window.getI18n(i18nBundle, "CONTINUE_WITH_SSO");
            secondaryLabel = window.getI18n(i18nBundle, "AUTH_PANEL_BACK_TO_LOGIN");
        }else if(mode === INLINE_AUTH_MODES.MAGIC_CODE){
            title = window.getI18n(i18nBundle, "MAGIC_CODE_CODE_PROMPT_TITLE");
            description = window.getI18n(i18nBundle, "MAGIC_CODE_CODE_PROMPT_TEXT").replace("%EMAIL%", email);
            primaryLabel = window.getI18n(i18nBundle, "MAGIC_CODE_VERIFY_BUTTON_LABEL");
            secondaryLabel = window.getI18n(i18nBundle, "AUTH_PANEL_USE_ANOTHER_EMAIL");
        }else if(mode === INLINE_AUTH_MODES.RESET_PASSWORD){
            title = window.getI18n(i18nBundle, "RESET_PASSWORD");
            description = window.getI18n(i18nBundle, "RESET_PASSWORD_INSTRUCTIONS");
            primaryLabel = window.getI18n(i18nBundle, "RESET_PASSWORD_SEND_BUTTON_LABEL");
            secondaryLabel = window.getI18n(i18nBundle, "AUTH_PANEL_BACK_TO_LOGIN");
        }else if(mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
            title = window.getI18n(i18nBundle, "EMAIL_VERIFICATION_PANEL_TITLE");
            description = window.getI18n(i18nBundle, "EMAIL_VERIFICATION_PANEL_TEXT").replace("%EMAIL%", email);
            primaryLabel = window.getI18n(i18nBundle, "EMAIL_VERIFICATION_VERIFY_BUTTON_LABEL");
            secondaryLabel = window.getI18n(i18nBundle, "AUTH_PANEL_CANCEL");
        }

        this._inlineAuthState = {
            mode: mode,
            email: email,
            pendingAuthenticationToken: resolvedOptions.pendingAuthenticationToken || null,
        };
        if(this.loginForm$el){
            this.loginForm$el.addClass("authFlowModeActive");
        }

        this.inlineAuthPanelTitle$el.text(title);
        this.inlineAuthPanelDescription$el.text(description);
        this.inlineAuthPrimaryBtn$el.text(primaryLabel);
        this.inlineAuthSecondaryBtn$el.text(secondaryLabel);
        this.clearInlineAuthError();

        const shouldShowEmailField = mode === INLINE_AUTH_MODES.MAGIC_EMAIL || mode === INLINE_AUTH_MODES.RESET_PASSWORD || mode === INLINE_AUTH_MODES.SSO_EMAIL;
        const shouldShowCodeField = mode === INLINE_AUTH_MODES.MAGIC_CODE || mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION;
        this.inlineAuthEmailFieldWrapper$el.toggle(shouldShowEmailField);
        this.inlineAuthCodeFieldWrapper$el.toggle(shouldShowCodeField);
        this.inlineAuthEmailField$el.val(shouldShowEmailField ? email : "");
        this.inlineAuthCodeField$el.val("");

        this.inlineAuthPanel$el.show();
        this.onInlineAuthFieldChanged();

        if(shouldShowEmailField){
            this.inlineAuthEmailField$el.focus();
        }else if(shouldShowCodeField){
            this.inlineAuthCodeField$el.focus();
        }
    },

    getInlineAuthData : function(){
        return {
            mode: this._inlineAuthState ? this._inlineAuthState.mode : null,
            email: this.inlineAuthEmailField$el && this.inlineAuthEmailField$el.is(":visible") ?
                this.inlineAuthEmailField$el.val().trim().toLowerCase() :
                (this._inlineAuthState && this._inlineAuthState.email ? this._inlineAuthState.email : ""),
            code: this.inlineAuthCodeField$el && this.inlineAuthCodeField$el.is(":visible") ?
                this.inlineAuthCodeField$el.val().toString().trim() :
                "",
            pendingAuthenticationToken: this._inlineAuthState ? this._inlineAuthState.pendingAuthenticationToken : null,
        };
    },

    onBeforeRemoveFromPage : function(){
        this.trigger("beforeRemoveFromPage", this);
        if(this._mousetrapObj){
            this._mousetrapObj.unbind("enter");
        }
    },

    onRemovedFromPage : function(){
        this.undelegateEvents();
        this.$el.removeData().unbind();
        if(this._onViewportHeightChangedFunctionRef && window[this._onViewportHeightChangedFunctionRef]){
            window.removeEventListener('resize', window[this._onViewportHeightChangedFunctionRef]);
            delete window[this._onViewportHeightChangedFunctionRef];
        }
        this.trigger("removedFromPage", this);
    },

    onFieldValueChanged : function(){
        if(this.isAllMandatoryFieldsFilled()){
            this.trebbleLogo$el.css("color", this._enabledColor);
            this.loginBtn$el.removeClass("disabled").addClass("enabled");
            this.loginBtn$el.attr("aria-disabled", "false");
        }else{
            this.trebbleLogo$el.css("color", this._disabledColor);
            this.loginBtn$el.removeClass("enabled").addClass("disabled");
            this.loginBtn$el.attr("aria-disabled", "true");
        }
    },

    isAllMandatoryFieldsFilled : function(){
        return this.$el.find("#usernameFieldInput").val() && this.$el.find("#passwordField").val();
    },

    _consumeAuthErrorQueryParam : function(){
        try{
            const searchParams = new URLSearchParams(
                Utils.getInstance().cleanQueryString(window.location.search || ""),
            );
            const authError = searchParams.get("authError") || searchParams.get("error");
            if(!authError){
                return null;
            }

            searchParams.delete("authError");
            searchParams.delete("error");
            const updatedQueryString = searchParams.toString();
            const updatedUrl = window.location.pathname + (updatedQueryString ? "?" + updatedQueryString : "") + window.location.hash;
            if(window.history && window.history.replaceState){
                window.history.replaceState(null, "", updatedUrl);
            }
            return authError;
        }catch(error){
            console.error(error);
            return null;
        }
    },

    _onViewportHeightChanged : function(){
        const headerHeight = shouldWaitForCordovaBootstrap() ? 0 : 54;
        this.$el.find(".ui-content").css("height", (window.getDocumentClienHeight() - headerHeight) + "px");
    },

    onUserNameFieldKeyUp :function(){
        this.usernameField$el.val(this.usernameField$el.val().replace(/ /g, "_").toLowerCase());
    },

    close : function(){
        const p = new RSVP.Promise((function(resolve, reject){
            try{
                this.$el.on({
                    popupafterclose: (function() {
                        try{
                            resolve();
                        }catch(error){
                            reject(error);
                        }
                    }).bind(this)
                });
            }catch(error){
                reject(error);
            }
        }).bind(this));
        this.$el.popup('close');
        return p;
    },

    _onGoogleLoginSuccess : function(googleUser){
        this.trigger("loginWithGoogleBtnSuccess", googleUser);
    },

    _onGoogleLoginFailed : function(error){
        this.trigger("loginWithGoogleBtnFailed", error);
    },

    _onPageShow: function(){
        $.mobile.resetActivePageHeight();
    },

    render : function(){
        const options = {};
        options.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
        options.doNotAllowGuestLogin = this._doNotAllowGuestLogin;
        options.ti18n = this._showAsPopup ? popupi18n : pagei18n;
        this._ti18n = options.ti18n;
        options.showOrganizationLogin = this._showOrganizationLogin;
        options.clickingOnSocialLoginWillSignupAutomatically = this._clickingOnSocialLoginWillSignupAutomatically;
        options.showAppleAuthButtons = this.shouldShowAppleAuthButtons();
        options.showFacebookAuthButtons = !this.shouldUseHostedSocialAuthButtons();
        const authError = !this._showAsPopup ? this._consumeAuthErrorQueryParam() : null;
        options.authError = authError;

        if(!this._showAsPopup){
            this.$el.html(this._getTemplate()(options));
            this.setElement(this.$el.find("div").first());
            this.$el.page();
            this.$el.on("pagehide", this._onPageHide.bind(this));
            const functionUniqueGlobalName = "onViewportHeightChangeForLoginPage" + (new Date()).getTime();
            window[functionUniqueGlobalName] = this._onViewportHeightChanged.bind(this);
            this._onViewportHeightChangedFunctionRef = functionUniqueGlobalName;
            window.addEventListener('resize', window[functionUniqueGlobalName]);
            this.$el.on("pageshow", this._onPageShow.bind(this));

            this.trebbleLogo$el = this.$el.find(".icon-trebble-icon-2ton");
            this.loginBtn$el = this.$el.find("#LoginBtn");
            this.loginForm$el = this.$el.find("#loginForm");
            const shouldUseHostedSocialButtons = this.shouldUseHostedSocialAuthButtons();
            const shouldShowAppleAuthButtons = this.shouldShowAppleAuthButtons();
            if(!shouldShowAppleAuthButtons){
                this.$el.find("#LoginWithAppleBtn").hide();
            }
            if(shouldWaitForCordovaBootstrap()){
                if(shouldUseHostedSocialButtons){
                    if(shouldShowAppleAuthButtons){
                        this.$el.find("#LoginWithAppleBtn").insertBefore(this.$el.find("#LoginWithGoogleBtn"));
                    }
                    this.$el.find("#LoginWithFacebookBtn").hide();
                }else if(window.isIOSMobileDevice && shouldShowAppleAuthButtons){
                    this.$el.find("#LoginWithAppleBtn").insertBefore(this.$el.find("#LoginWithFacebookBtn"));
                }else{
                    this.$el.find("#LoginWithAppleBtn").hide();
                    this.$el.find("#LoginWithGoogleBtn").insertBefore(this.$el.find("#LoginWithFacebookBtn"));
                }
            }

            this.usernameField$el = this.$el.find("#usernameFieldInput");
            this.$el.find(".formField").on("click blur keyup input", this.onFieldValueChanged.bind(this));
            this._mousetrapObj = Mousetrap(this.$el.find("#loginForm").get(0)).bind('enter', (function() {
                if(this._inlineAuthState){
                    if(this.inlineAuthPrimaryBtn$el && this.inlineAuthPrimaryBtn$el.hasClass("enabled")){
                        this.onInlineAuthPrimaryBtnTapped();
                    }
                    return;
                }
                if(this.loginBtn$el && this.loginBtn$el.hasClass("enabled")){
                    this.onLoginBtnTapped();
                }
            }).bind(this));
            this.inlineAuthPanel$el = this.$el.find("#InlineAuthPanel");
            this.inlineAuthPanelTitle$el = this.$el.find("#InlineAuthPanelTitle");
            this.inlineAuthPanelDescription$el = this.$el.find("#InlineAuthPanelDescription");
            this.inlineAuthError$el = this.$el.find("#InlineAuthError");
            this.inlineAuthEmailFieldWrapper$el = this.$el.find("#InlineAuthEmailFieldWrapper");
            this.inlineAuthCodeFieldWrapper$el = this.$el.find("#InlineAuthCodeFieldWrapper");
            this.inlineAuthEmailField$el = this.$el.find("#InlineAuthEmailField");
            this.inlineAuthCodeField$el = this.$el.find("#InlineAuthCodeField");
            this.inlineAuthPrimaryBtn$el = this.$el.find("#InlineAuthPrimaryBtn");
            this.inlineAuthSecondaryBtn$el = this.$el.find("#InlineAuthSecondaryBtn");

            const loginWithGoogleBtn$el = this.$el.find("#LoginWithGoogleBtn");
            if(!loginWithGoogleBtn$el.hasClass("hide")){
                loginWithGoogleBtn$el.addClass("hide");
            }

            if(shouldUseHostedSocialButtons){
                loginWithGoogleBtn$el.removeClass("hide");
                this.$el.find(".google_button_container").hide();
                this.$el.find("#LoginWithFacebookBtn").hide();
                this.$el.find("#LoginWithAppleBtn").css("display", shouldShowAppleAuthButtons ? "flex" : "none");
            }else{
                GooglePlusHelper.getInstance().attachClickHandlerToElementForLoginIntent(
                    loginWithGoogleBtn$el.get(0),
                    {},
                    this._onGoogleLoginSuccess.bind(this),
                    this._onGoogleLoginFailed.bind(this),
                    USE_NEW_GOOGE_API_ON_WEB,
                    this.$el.find(".google_button_container").get(0),
                    {text:"signin_with"},
                ).then((function(){
                    if(!USE_NEW_GOOGE_API_ON_WEB || window.isInMobileAppContext()){
                        loginWithGoogleBtn$el.removeClass("hide");
                    }
                }).bind(this));
            }

            this.usernameField$el.focus();
            this._onViewportHeightChanged();
            this.onFieldValueChanged();
            return RSVP.Promise.resolve(this);
        }

        return window.trebble.pageContainerReadyPromise.then((function(){
            this.$el.html(this.ptemplate(options));
            this.setElement(this.$el.find("div").first());
            const elementId = this.$el.attr('id');

            this.$el.on({
                popupbeforeposition: (function() {
                    const maxHeight = $(window).height() + "px";
                    const width = $(window).width() + "px";
                    this.$el.css("height", maxHeight);
                    this.$el.css("width", width);
                }).bind(this)
            });
            this.$el.on({
                popupafterclose: (function() {
                    this.onRemovedFromPage();
                    this.trigger("closed");
                    $(".ui-page-active").css("position", this._currenPagePositionValue);
                    this.$el.find("paper-input").detach();
                    this.$el.find("paper-input-decorator").detach();
                    this.remove();
                    $("#loginPoppup-popup").remove();
                    $("#loginPoppup-placeholder").remove();
                    $("#loginPoppup-screen").remove();
                    this.undelegateEvents();
                }).bind(this)
            });
            $.mobile.pageContainer.prepend(this.$el);
            this.$el.popup({transition:"fade", dismissible: false, tolerance: "0,0"});
            this.$el.find("#closeBtn").on("click", this.close.bind(this));
            if(elementId){
                const screenPopup$el = $("#" + elementId + "-screen");
                $.mobile.pageContainer.remove("#" + elementId + "-screen");
                $.mobile.pageContainer.prepend(screenPopup$el);
            }

            this.$el.enhanceWithin();
            this.$el.on("pageshow", this._onPageShow.bind(this));
            this.$el.popup('open');

            const functionUniqueGlobalName = "onViewportHeightChangeForLoginPage" + (new Date()).getTime();
            window[functionUniqueGlobalName] = this._onViewportHeightChanged.bind(this);
            this._onViewportHeightChangedFunctionRef = functionUniqueGlobalName;
            window.addEventListener('resize', window[functionUniqueGlobalName]);
            this.trebbleLogo$el = this.$el.find(".icon-trebble-icon-2ton");
            this.loginBtn$el = this.$el.find("#LoginBtn");
            this.loginForm$el = this.$el.find("#loginForm");
            const shouldUseHostedSocialButtons = this.shouldUseHostedSocialAuthButtons();
            const shouldShowAppleAuthButtons = this.shouldShowAppleAuthButtons();
            if(!shouldShowAppleAuthButtons){
                this.$el.find("#LoginWithAppleBtn").hide();
            }

            this.usernameField$el = this.$el.find("#usernameFieldInput");
            this.usernameField$el.on("click blur keyup input", this.onUserNameFieldKeyUp.bind(this));
            this.$el.find(".formField").on("click blur keyup input", this.onFieldValueChanged.bind(this));
            this._mousetrapObj = Mousetrap(this.$el.find("#loginForm").get(0)).bind('enter', (function() {
                if(this._inlineAuthState){
                    if(this.inlineAuthPrimaryBtn$el && this.inlineAuthPrimaryBtn$el.hasClass("enabled")){
                        this.onInlineAuthPrimaryBtnTapped();
                    }
                    return;
                }
                if(this.loginBtn$el && this.loginBtn$el.hasClass("enabled")){
                    this.onLoginBtnTapped();
                }
            }).bind(this));
            this.inlineAuthPanel$el = this.$el.find("#InlineAuthPanel");
            this.inlineAuthPanelTitle$el = this.$el.find("#InlineAuthPanelTitle");
            this.inlineAuthPanelDescription$el = this.$el.find("#InlineAuthPanelDescription");
            this.inlineAuthError$el = this.$el.find("#InlineAuthError");
            this.inlineAuthEmailFieldWrapper$el = this.$el.find("#InlineAuthEmailFieldWrapper");
            this.inlineAuthCodeFieldWrapper$el = this.$el.find("#InlineAuthCodeFieldWrapper");
            this.inlineAuthEmailField$el = this.$el.find("#InlineAuthEmailField");
            this.inlineAuthCodeField$el = this.$el.find("#InlineAuthCodeField");
            this.inlineAuthPrimaryBtn$el = this.$el.find("#InlineAuthPrimaryBtn");
            this.inlineAuthSecondaryBtn$el = this.$el.find("#InlineAuthSecondaryBtn");

            const loginWithGoogleBtn$el = this.$el.find("#LoginWithGoogleBtn");
            if(!loginWithGoogleBtn$el.hasClass("hide")){
                loginWithGoogleBtn$el.addClass("hide");
            }

            if(shouldUseHostedSocialButtons){
                loginWithGoogleBtn$el.removeClass("hide");
                this.$el.find(".google_button_container").hide();
                this.$el.find("#LoginWithFacebookBtn").hide();
                this.$el.find("#LoginWithAppleBtn").css("display", shouldShowAppleAuthButtons ? "flex" : "none");
            }else{
                GooglePlusHelper.getInstance().attachClickHandlerToElementForLoginIntent(
                    loginWithGoogleBtn$el.get(0),
                    {},
                    this._onGoogleLoginSuccess.bind(this),
                    this._onGoogleLoginFailed.bind(this),
                    USE_NEW_GOOGE_API_ON_WEB,
                    this.$el.find(".google_button_container").get(0),
                    {text:"signin_with"},
                ).then((function(){
                    // Mirror the page-flow branch above: legacy button only
                    // shows when the new Google API isn't being used (the new
                    // API renders its own button) or when running in a mobile
                    // app context. With the old check inverted, popup login
                    // unhid the legacy button whenever the new API was on.
                    if(!USE_NEW_GOOGE_API_ON_WEB || window.isInMobileAppContext()){
                        loginWithGoogleBtn$el.removeClass("hide");
                    }
                }).bind(this));
            }

            this.usernameField$el.focus();
            this._onViewportHeightChanged();
            this.onFieldValueChanged();
            return this;
        }).bind(this));
    },

    setRemoveOnHide : function(removeOnHide){
        this._removeOnHide = removeOnHide;
    },

    _onPageHide : function(){
        if(this._removeOnHide){
            this.onBeforeRemoveFromPage();
            this.remove();
            this.onRemovedFromPage();
        }
    }
});

export default LoginPageView;
